module.exports = "/static-assets/_next/static/images/ratRaceAnimation-a518559260cc1248ed9633f89a0ac992.mp4";